// Browser and API clocks can differ by milliseconds even with healthy NTP.
// This allowance applies ONLY to the snapshot's evaluatedAt plausibility.
// Never add it to validUntil, quota/stock age, order expiry or payment grants.
export const SERVER_SNAPSHOT_CLOCK_SKEW_MS = 5000;

export function isServerSnapshotTimeValid(evaluatedAt, now = Date.now(), maxAgeMs = null) {
  if (!Number.isSafeInteger(now) || now < 0 ||
    (maxAgeMs !== null && (!Number.isSafeInteger(maxAgeMs) || maxAgeMs < 0)) ||
    typeof evaluatedAt !== 'string' || !/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d\.\d{3}Z$/.test(evaluatedAt)) return false;
  const evaluated = Date.parse(evaluatedAt);
  if (!Number.isSafeInteger(evaluated) || new Date(evaluated).toISOString() !== evaluatedAt) return false;
  const age = now - evaluated;
  return age >= -SERVER_SNAPSHOT_CLOCK_SKEW_MS && (maxAgeMs === null || age <= maxAgeMs);
}
